
// export function StatisticGroup({ cmpType, field, group, board }) {
//     function getStatisticsStatus(cmp) {
//         const labels = group.tasks.map(task => {
//             return board.labels.find(label => label.title === task[cmp])
//         })
        
//         const mapLabel = labels.reduce((acc, label) => {
//             if (acc[label.color]) acc[label.color]++
//             else acc[label.color] = 1
//             return acc
//         }, {})
//         const result = []
//         for (let key in mapLabel) {
//             result.push({ background: key, width: `${mapLabel[key] / labels.length * 100}%` })
//         }
//         return result
//     }

//     // function getStatisticsNumber() {
//     //     const sumOfNumbers = group.tasks.reduce((acc, task) => {
//     //         if (task.number) return acc + task.number
//     //         return acc
//     //     }, 0)
//     //     return sumOfNumbers
//     // }
    
//     function getStatisticsNumber(field) {
//         const sumOfNumbers = group.actividades.reduce((acc, actividad) => {
//             const fieldValue = parseFloat(actividad[field]); // Convertir string a número

//             if (!isNaN(fieldValue)) {
//                 return acc + fieldValue;
//             } else {
//                 return acc;
//             }
//         }, 0);
    
//         return sumOfNumbers;
//     }

//     function getStatisticsResult() {
//         switch (cmpType) {
//             case 'member-picker':
//                 return
//             case 'status-picker':
//                 return <GetStatisticsLabel statisticLabels={getStatisticsStatus('status')} />
//             case 'priority-picker':
//                 return <GetStatisticsLabel statisticLabels={getStatisticsStatus('priority')} />
//             case 'date-picker':
//                 return []
//             case 'number-picker':
//                 return <GetStatisticsNumber statisticNumber={getStatisticsNumber('meta')} />
//             case 'number-picker2':
//                     return <GetStatisticsNumber statisticNumber={getStatisticsNumber('ejecucion')} />
//             default: return []
//         }
//     }
//     return (
//         <>
//             {getStatisticsResult()}
//         </>
//     )
// }

// function GetStatisticsLabel({ statisticLabels }) {
//     return (
//         statisticLabels.map((label, idx) => {
//             return <span data-testid={`label-${idx}`} key={idx} style={label} ></span>
//         })
//     )
// }

// function GetStatisticsNumber({ statisticNumber }) {
//     return (
//         <div role="contentinfo" className="statistic-number flex column align-center">
//             <span className="number">{statisticNumber}</span>
//             <span className="sum">suma</span>
//         </div>
//     )
// }

// function GetEjecucionNumber({ statisticNumber }) {
//     return (
//         <div role="contentinfo" className="statistic-number flex column align-center">
//             <span className="number">{statisticNumber}</span>
//             <span className="sum">Suma</span>
//         </div>
//     )
// }




export function StatisticGroup({ cmpType, field, group, board }) {
    function getStatisticsStatus(cmp) {
        const labels = group.tasks.map(task => {
            return board.labels.find(label => label.title === task[cmp])
        })
        
        const mapLabel = labels.reduce((acc, label) => {
            if (acc[label.color]) acc[label.color]++
            else acc[label.color] = 1
            return acc
        }, {})
        const result = []
        for (let key in mapLabel) {
            result.push({ background: key, width: `${mapLabel[key] / labels.length * 100}%` })
        }
        return result
    }

    function getStatisticsNumber(field) {
        const sumOfNumbers = group.actividades.reduce((acc, actividad) => {
            const fieldValue = parseFloat(actividad[field]); // Convertir string a número

            if (!isNaN(fieldValue)) {
                return acc + fieldValue;
            } else {
                return acc;
            }
        }, 0);
    
        return sumOfNumbers;
    }

    //Version Funional sin restricciones 

    // // Nueva función para calcular el progreso
    // function calculateProgressForActivities() {
    //     const totalProgress = group.actividades.reduce((acc, actividad) => {
    //         const meta = parseFloat(actividad.meta) || 0; // Si es NaN, convierte a 0
    //         const ejecucion = parseFloat(actividad.ejecucion) || 0; // Si es NaN, convierte a 0
            
    //         let progress = calculateProgress(meta, ejecucion);
            
    //         if (progress > 100) progress = 100; // Limita el progreso a 100
            
    //         return acc + progress;
    //     }, 0);
        
    //     const averageProgress = group.actividades.length > 0 
    //         ? (totalProgress / group.actividades.length).toFixed(2) // Mantiene 2 dígitos después del punto
    //         : 0; // Si no hay actividades, el promedio es 0
        
    //     return `${averageProgress}%`;
    // }

    // // Reutilizamos tu función calculateProgress con manejo de valores nulos
    // const calculateProgress = (meta, ejecucion) => {
    //     if (!meta || meta === 0) return 0;
    //     return Math.round((ejecucion / meta) * 100);
    // };

    //FIN Version Funional sin restricciones 


    //Version de prueba Funcion con restricciones
    function calculateProgressForActivities() {
        // Filtra actividades para excluir las que tienen fk_estado_id igual a 4
        const filteredActivities = group.actividades.filter(actividad => actividad.fk_estado_id !== 4);
    
        const totalProgress = filteredActivities.reduce((acc, actividad) => {
            const meta = parseFloat(actividad.meta) || 0; // Si es NaN, convierte a 0
            const ejecucion = parseFloat(actividad.ejecucion) || 0; // Si es NaN, convierte a 0
            const files = actividad.archivosactividad || []; // Obtén los archivos directamente de la actividad
            const approvedFilesCount = files.filter(file => file.estado_verificable?.toLowerCase() === "aprobado").length;
    
            let progress = calculateProgress(meta, ejecucion, approvedFilesCount, files.length);
            if (progress > 100) progress = 100; // Limita el progreso a 100
    
            return acc + progress;
        }, 0);
    
        const averageProgress = filteredActivities.length > 0 
            ? (totalProgress / filteredActivities.length).toFixed(2) // Mantiene 2 dígitos después del punto
            : 0; // Si no hay actividades válidas, el promedio es 0
    
        return `${averageProgress}%`;
    }
    
    // Función reutilizable para calcular el progreso
    function calculateProgress(meta, ejecucion, approvedFilesCount, totalFilesCount) {
        if (!meta || meta === 0 || !totalFilesCount || totalFilesCount === 0) return 0;
    
        const valor1 = ejecucion / totalFilesCount; // Proporción de ejecución por archivo
        const multiplicacion = valor1 * approvedFilesCount; // Ponderación por archivos aprobados
    
        return Math.round((multiplicacion / meta) * 100); // Progreso en porcentaje
    }

    //FIN Version de prueba Funcion con restricciones
    
    

    function getStatisticsResult() {
        switch (cmpType) {
            case 'member-picker':
                return;
            case 'status-picker':
                return <GetStatisticsLabel statisticLabels={getStatisticsStatus('status')} />;
            case 'priority-picker':
                return <GetStatisticsLabel statisticLabels={getStatisticsStatus('priority')} />;
            case 'date-picker':
                return [];
            case 'number-picker':
                return <GetStatisticsNumber statisticNumber={getStatisticsNumber('meta')} />;
            case 'number-picker2':
                return <GetStatisticsNumber statisticNumber={getStatisticsNumber('ejecucion')} />;
            case 'number-picker3':
                return <GetStatisticsNumber statisticNumber={getStatisticsNumber('monto')} />;
            case 'progress-picker': // Nuevo caso para el progreso
                return <GetStatisticsNumber statisticNumber={calculateProgressForActivities()} />;
            default: return [];
        }
    }

    return (
        <>
            {getStatisticsResult()}
        </>
    );
}

function GetStatisticsLabel({ statisticLabels }) {
    return (
        statisticLabels.map((label, idx) => {
            return <span data-testid={`label-${idx}`} key={idx} style={label} ></span>
        })
    );
}

function GetStatisticsNumber({ statisticNumber, isPercentage }) {
    return (
        <div role="contentinfo" className="statistic-number flex column align-center">
            <span className="number"><b>{statisticNumber}</b></span>
            <span className="sum">{isPercentage ? "porcentaje" : "suma"}</span>
        </div>
    );
}
